<template>
  <div>
    <div id="activity-detail-wrapper">
      <div id="activity-detail">
        <a @click="$router.go(-1)" :to="-1" id="back-to-activities">
          <i class="fa fa-chevron-left" aria-hidden="true" />
          {{ $t('activityDetail.back') }}
        </a>

        <image-view
          id="cover-image"
          :src="coverImage"
          group="activityPhotos"
          :title="title"
          vImgEnabled="true"
        />
        <div id="activity-detail-content" v-html="html" />
          <div id="images">
          <div id="image-1" class="image-wrapper" v-if="image1">
            <image-view
              class="image"
              :src="image1"
              group="activityPhotos"
              :title="imageDesc1"
              vImgEnabled="true"
            />
              
            <div class="text">{{ imageDesc1 }}</div>
          </div>
          <div id="image-2" class="image-wrapper" v-if="image2">
            <image-view
              class="image"
              :src="image2"
              group="activityPhotos"
              :title="imageDesc2"
              vImgEnabled="true"
            />
            <div class="text">{{ imageDesc2 }}</div>
          </div>
        </div>
        <div>
          <a v-if="link" target="_blank" :href="link" class="button" id="participate-button">
            {{ $t('activities.participate')}}
          </a>
          <div style="clear:both;"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivityById } from '../models/Activity';
import ImageView from './ImageView';

export default {
  name: 'ActivityDetail',
  components: {
    'image-view': ImageView,
  },
  data() {
    return {
      coverImage: null,
      title: null,
      html: '',
      image1: null,
      imageDesc1: '',
      image2: null,
      imageDesc2: '',
      link: '',
    };
  },
  computed: {
    category() {
      return this.$route.params.category;
    },
  },
  mounted() {
    getActivityById(this.$route.params.activityId).then((activity) => {
      this.title = activity.title;
      this.coverImage = activity.coverImage ? activity.coverImage.url : null;
      this.html = activity.htmlContent;
      this.imageDesc1 = activity.photoDesc1;
      this.imageDesc2 = activity.photoDesc2;
      this.image1 = activity.photo1 ? activity.photo1.url : null;
      this.image2 = activity.photo2 ? activity.photo2.url : null;
      this.link = activity.link;
    });
  },
};
</script>

<style lang="sass" scoped>
  @import "../styles/variables.sass"

  #activity-detail-wrapper
    padding: 42px 85px
    padding-top: 0
    @media #{$mobile}
      padding: 30px 20px

  #activity-detail
    max-width: 740px
    margin: 0 auto
    margin-top: 45px
    @media #{$mobile}
      margin-top: 15px

    #back-to-activities
      color: $fountain-blue
      font-size: 18px
      margin-bottom: 20px
      display: inline-block
      line-height: 18px
      vertical-align: middle

      .fa
        font-size: 18px
        line-height: 18px

    #cover-image
      padding-bottom: 56%
      background-size: cover
      background-position: center
      margin-bottom: 30px

    #images
      display: flex
      margin-top: 36px

      @media #{$mobile}
        flex-wrap: wrap
        justify-content: center
        flex-direction: column
        align-items: center
        .image-wrapper
          flex: 0

      @media #{$desktop}
        #image-1
          margin-right: 35px

      .image-wrapper
        margin-bottom: 32px
        max-width: 352px

        .image
          padding-bottom: 56%
          background-size: cover
          background-position: center
          border: 1px solid $silver

          @media #{$mobile}
            width: 305px

        .text
          text-align: center
          color: $gray
          margin-top: 12px

        @media #{$desktop}
          flex: 1 0 0

    #participate-button
      width: 154px
      height: 44px
      background-color: $macaroni-and-cheese
      color: $white
      @media #{$desktop}
        float: right

      @media #{$mobile}
        width: 100%
        height: 44px

</style>

<style lang="sass">
  @import "../styles/font.sass"

  #activity-detail-content *
      font-family: $body-family !important

</style>



// WEBPACK FOOTER //
// src/components/ActivityDetail.vue